import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';

import {
  PHOTO_MANAGER_SUBSCRIPTION_BILLING_PERIOD,
  PHOTO_MANAGER_SUBSCRIPTION_FEATURES,
} from '../../../../apps/pro/views/Account/AccountPhotoManagerSettings/components/PhotoManagerSubscriptionCheckout/helpers';
import { formatPriceForDisplay } from '../../../../util/format-money';
import Button from '../../../../components/global/Button';

const propTypes = {
  photoManagerSubscriptionItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ),
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  skipFreeTrial: PropTypes.bool,
  isWaldoProFreeRegister: PropTypes.bool,
};

const RegisterPhotoManagerForm = ({
  handleChange,
  photoManagerSubscriptionItems,
  handleSubmit,
  skipFreeTrial,
  isWaldoProFreeRegister,
}) => {
  const history = useHistory();
  const location = useLocation();
  const search = qs.parse(location.search);

  if (!photoManagerSubscriptionItems) {
    return null;
  }

  const yearlyPlan = photoManagerSubscriptionItems.find(
    item =>
      item.billing_period === PHOTO_MANAGER_SUBSCRIPTION_BILLING_PERIOD.YEARLY,
  );

  return (
    <div className="register-view-photo-manager-form">
      <ul className="photo-manager-subscription-features mb-0">
        {PHOTO_MANAGER_SUBSCRIPTION_FEATURES.map(feature => (
          <li key={feature} className="text-dark">
            {feature}
          </li>
        ))}
      </ul>
      {yearlyPlan && isWaldoProFreeRegister && (
        <div className="my-2 text-center">
          <Button
            onClick={() => {
              handleChange({
                target: {
                  name: 'plan_id',
                  value: yearlyPlan.id,
                },
              });
              handleSubmit();
            }}
          >
            Get started for Free!
          </Button>
        </div>
      )}
      {yearlyPlan && !isWaldoProFreeRegister && (
        <div className="my-2 text-center">
          <Button
            onClick={() => {
              handleChange({
                target: {
                  name: 'plan_id',
                  value: yearlyPlan.id,
                },
              });
              handleSubmit();
            }}
          >
            {skipFreeTrial ? (
              <p className="mb-0 text-center">
                ${formatPriceForDisplay(yearlyPlan.price.value, true)} / year
              </p>
            ) : (
              <p className="mb-0 text-center">
                Start {yearlyPlan.trial_days}&ndash;day free trial <br />
                <span className={skipFreeTrial ? undefined : 'text-normal'}>
                  (${formatPriceForDisplay(yearlyPlan.price.value, true)} / year
                  after trial ends)
                </span>
              </p>
            )}
          </Button>
        </div>
      )}
      {!isWaldoProFreeRegister && (
        <div className="text-center mt-2 text-sm">
          Are you a pro photographer?{' '}
          <Button
            btnStyle="link"
            btnSize="sm"
            onClick={() =>
              history.replace({
                pathname: `/auth/register`,
                search: `?${qs.stringify({
                  ...(search ?? {}),
                  is_waldo_pro: true,
                  skip_free_trial: true,
                })}`,
              })
            }
          >
            Sign up here
          </Button>
        </div>
      )}
    </div>
  );
};

RegisterPhotoManagerForm.propTypes = propTypes;

export default RegisterPhotoManagerForm;
